/* eslint @typescript-eslint/no-explicit-any: 0 */
/* eslint @typescript-eslint/no-unused-vars: 0 */

import { Injectable } from '@angular/core';
import { AlertMessageService } from '@serpro/ngx-suite-rfb';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';

class Erro {
    constructor(public tipo: string, public mensagem: string) { }
}

@Injectable({
    providedIn: 'root'
})
export class ApiErrorHandlerService {
    constructor(private alertMessageService: AlertMessageService) { }

    /**
     * Substitui o handle() quando não se quer propagar o erro tratado para a página principal.
     * SIJUT / Aquino / 16-02-2024
     */
    ignoreErrors(noMsgsFor: number[] = []): (requestError: any) => Observable<any> {
        return (requestError: any): Observable<any> => {
            return throwError(() => requestError);
        }
    }

    handle(noMsgsFor: number[] = []): (requestError: any) => Observable<any> {
        return (requestError: any): Observable<any> => {
            if (!environment.production) {
                console.error('requestError', requestError);
            }

            if (noMsgsFor.find((e) => e === requestError.status)) {
                if (!environment.production) {
                    console.log(`Ignored: ${requestError.status}`);
                }
            } else {
                const erros = this.recuperarErros(requestError);
                erros.forEach((erro) => {
                    this.alertMessageService.error(erro.tipo, erro.mensagem);
                });
            }

            return throwError(() => requestError);
        };
    }

    private recuperarErros(requestError: any): Erro[] {
        switch (requestError.status) {
            case 401:
                return this.unauthorized(requestError);
            case 403:
                return this.forbidden(requestError);
            case 406:
                return this.notAcceptable(requestError);
            case 409:
                return this.conflict(requestError);
            default:
                return this.other(requestError);
        }
    }

    private other(requestError: any): Erro[] {
        const errors: Erro[] = [];
        try {
            const error = requestError.error;
            for (const prop in error) {
                if (
                    Object.prototype.hasOwnProperty.call(error, prop) &&
                    error[prop] &&
                    error[prop].forEach
                ) {
                    error[prop].forEach((item: any) => {
                        if (item.message) {
                            errors.push(new Erro('Erro de Validação', item.message));
                        }
                    });
                }
            }
        } catch (e) {
            if (!environment.production) {
                console.error('Translating Errors:', e);
            }
        }

        if (errors.length === 0) {
            errors.push(
                new Erro(
                    'Ocorreu um erro inesperado',
                    'Por favor, tente novamente mais tarde. Se o erro persistir, contate o suporte do sistema.'
                )
            );
        }

        return errors;
    }

    private unauthorized(requestError: any): Erro[] {
        return [
            new Erro('Não autorizado!', 'Você não tem autorização para executar essa transação.')
        ];
    }

    private forbidden(requestError: any): Erro[] {
        return [
            new Erro('Proibido!', 'Você não tem permissão para executar essa transação.')
        ];
    }

    private conflict(requestError: any): Erro[] {
        return [
            new Erro('Conflito!', 'Esse recurso já foi atualizado por outra transação.')
        ];
    }

    private notAcceptable(requestError: any): Erro[] {
        return [
            new Erro('Falha na operação', requestError.error['message'])
        ];
    }
}